export default {
  assetScope: {
    title: '资产使用规则',
    ruleTab: '使用规则',
    defaultTab: '默认策略',
    recycleTab: '回收站',
    addRule: '添加门店资产使用规则',
    ruleName: '规则名称',
    shopName: '门店名称',
    groupName: '门店组名称',
    targetName: '覆盖对象',
    matchType: '覆盖类型',
    matchShop: '指定门店',
    matchGroup: '指定门店组',
    useType: '使用方式',
    isUsed: '使用状态',
    used: '使用中',
    unused: '未使用',
    createTime: '创建时间',
    deleteTime: '删除时间',
    action: '操作',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    restore: '恢复',
    permanentDelete: '彻底删除',
    addTitle: '添加资产使用规则',
    basicInfo: '基础信息',
    usageSection: '使用方式',
    editTitle: '编辑资产使用规则',
    viewTitle: '查看资产使用规则',
    deleteTitle: '删除资产使用规则',
    confirmDelete: '确定要将该资产使用规则移入回收站吗？',
    confirmRestore: '确定要恢复该资产使用规则吗？',
    ruleNamePlaceholder: '请输入规则名称',
    targetPlaceholder: '请选择覆盖对象',
    remark: '备注',
    remarkPlaceholder: '请输入备注',
    save: '保存',
    confirm: '确认',
    select: '选择',
    selectShop: '选择门店',
    selectShopGroup: '选择门店组',
    searchName: '搜索名称或城市',
    selected: '已选择',
    shopCode: '门店编码',
    shopStatus: '门店状态',
    shopEnabled: '启用',
    shopDisabled: '停用',
    shopPending: '待开业',
    shopPlanned: '计划开业',
    shopOperating: '开业中',
    shopSuspended: '暂停营业',
    shopClosed: '永久关闭',
    region: '区域',
    city: '城市',
    ruleOccupancy: '规则占用',
    usageAvailable: '可设置使用规则',
    usageOccupied: '已有使用规则',
    usageSelected: '已被当前规则选择',
    shopCount: '门店数',
    coveredShopCount: '覆盖门店数',
    shopUnit: '家',
    occupied: '已被其他规则占用',
    defaultTitle: '默认策略',
    defaultDescription: '当会员资产没有匹配到使用规则时，按以下策略确定可使用范围。',
    policyRule: '规则范围内通用',
    policyRuleDesc: '会员资产可在当前规则覆盖的门店范围内使用。',
    policyTenant: '全租户通用',
    policyTenantDesc: '会员资产可在租户内所有门店使用。',
    policySource: '仅来源门店可用',
    policySourceDesc: '会员资产仅可在产生资产的来源门店使用。',
    saveDefault: '保存并实时生效',
    switchDefaultTitle: '切换默认策略',
    switchDefaultConfirmTitle: '确认切换默认策略',
    currentDefaultPolicy: '当前默认使用方式',
    nextDefaultPolicy: '切换后默认使用方式',
    switchEffective: '本次调整会影响',
    switchEffectiveNow: '实时生效',
    manualRulePriority: '手动规则优先',
    manualRulePriorityDesc: '仅影响未命中手动规则的资产',
    switchDefaultNotice: '本次调整会影响未手动配置规则门店的存量资产和新增资产可用范围，请确认后操作。',
    confirmSwitch: '确认切换',
    loadFailed: '加载失败',
    selectRequired: '请选择覆盖对象',
    nameRequired: '请输入规则名称',
    removeSuccess: '已移入回收站',
    restoreSuccess: '恢复成功',
    saveSuccess: '保存成功',
    noPermanentDelete: '暂未提供彻底删除接口',
    shop: '门店',
    group: '门店组',
  },
};
